import {
  getCompanyUsersStart,
  getCompanyUsersSuccess,
  getCompanyUsersFailure,
  addUserStart,
  addUserSuccess,
  addUserFailure,
  editUserStart,
  editUserSuccess,
  editUserFailure,
  fetchCompanyUsersStart,
  fetchCompanyUsersSuccess,
  fetchCompanyUsersError,
  fetchCollectionUsersStart,
  fetchCollectionUsersSuccess,
  fetchCollectionUsersError,
  addUserToCollectionStart,
  addUserToCollectionSuccess,
  addUserToCollectionFailure,
  removeUserFromCollectionStart,
  removeUserFromCollectionSuccess,
  removeUserFromCollectionFailure,
  setSelectedUser,
  resetSelectedUser,
  resetAlertBox,
  resetSnackbar,
  getResetPasswordStart,
  getResetPasswordSuccess,
  getResetPasswordFailure,
} from './user.slice';
import {
  fetchUsersByCompanyApi,
  addNewUserApi,
  editUserApi,
  fetchCollectionUsersApi,
  fetchCompanyUsersApi,
  addUserToCollectionApi,
  removeUserFromCollectionApi,
  sendResetPasswordApi,
} from '../api/user.api';

export const fetchAllUsers = () => async (dispatch) => {
  dispatch(getCompanyUsersStart());
  try {
    const response = await fetchUsersByCompanyApi();
    dispatch(getCompanyUsersSuccess(response.data));
  } catch (error) {
    dispatch(getCompanyUsersFailure(error.response.data));
  }
};

export const addUser = (userData) => async (dispatch) => {
  dispatch(addUserStart());
  try {
    const response = await addNewUserApi(userData);
    dispatch(addUserSuccess(response.data));
  } catch (error) {
    dispatch(addUserFailure(error.response.data));
  }
};

export const editUserFn = (userData) => async (dispatch) => {
  dispatch(editUserStart());
  try {
    const response = await editUserApi(userData);
    dispatch(editUserSuccess(response.data));
  } catch (error) {
    dispatch(editUserFailure(error.response.data));
  }
};

export const fetchCompanyUsers = (companyid) => async (dispatch) => {
  dispatch(fetchCompanyUsersStart());
  try {
    const response = await fetchCompanyUsersApi(companyid);
    dispatch(fetchCompanyUsersSuccess(response.data));
  } catch (error) {
    dispatch(fetchCompanyUsersError(error.response.data));
  }
};

export const fetchCollectionUsers = (collectionid) => async (dispatch) => {
  dispatch(fetchCollectionUsersStart());
  try {
    const response = await fetchCollectionUsersApi(collectionid);
    dispatch(fetchCollectionUsersSuccess(response.data));
  } catch (error) {
    dispatch(fetchCollectionUsersError(error.response.data));
  }
};

export const assignCollectionToUser = (data) => async (dispatch) => {
  dispatch(addUserToCollectionStart());
  try {
    await addUserToCollectionApi(data);
    dispatch(addUserToCollectionSuccess());
  } catch (error) {
    dispatch(addUserToCollectionFailure(error.response.data));
  }
};

export const deleteUserFromCollection = (data) => async (dispatch) => {
  dispatch(removeUserFromCollectionStart());
  try {
    const response = await removeUserFromCollectionApi(data);
    dispatch(removeUserFromCollectionSuccess());
    return response.data;
  } catch (error) {
    dispatch(removeUserFromCollectionFailure(error.response.data));
  }
};

export const selectUserForEdit = (data) => (dispatch) => {
  dispatch(setSelectedUser(data));
};

export const resetEdit = () => (dispatch) => {
  dispatch(resetSelectedUser());
};

export const resetAlert = () => (dispatch) => {
  dispatch(resetAlertBox());
};

export const resetSnackbarDetails = () => async (dispatch) => {
  dispatch(resetSnackbar());
};

export const resetPassword = (userID) => async (dispatch) => {
  dispatch(getResetPasswordStart());
  try {
    await sendResetPasswordApi(userID);
    dispatch(getResetPasswordSuccess());
    return true;
  } catch (error) {
    dispatch(getResetPasswordFailure(error.response.data));
    return false;
  }
};
